__turbopack_context__.v({
  "icon": "QRqthq_icon",
  "message": "QRqthq_message",
  "shake": "QRqthq_shake",
  "wrapper": "QRqthq_wrapper",
});
